module.exports = __webpack_public_path__ + "static/img/qr_kefu.c19b65d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/qr_kefu.png
// module id = 2Waz
// module chunks = 0